(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
'use strict';

/**
 * Simple type detection
 *
 * @param {*} input
 * @return {string} type
 */
function type(input) {
    return input === null ? 'null' : Array.isArray(input) ? 'array' : typeof input;
}

/**
 * Error thrown if an Alphabet receives less characters than needed
 *
 * @class InvalidInputError
 * @extends {Error}
 */
let InvalidInputError$1 = class InvalidInputError extends Error {
    /**
     * Creates an instance of InvalidInputError
     *
     * @memberof InvalidInputError
     */
    constructor(source) {
        super(`Alphabets requires a string(able), got (${type(source)}) ${source}`);
        const { constructor, constructor: { name } } = this;
        this.name = name;
        Error.captureStackTrace(this, constructor);
    }
};

/**
 * Error thrown if an Alphabet receives duplicate characters
 *
 * @class DuplicateCharacterError
 * @extends {Error}
 */
let DuplicateCharacterError$1 = class DuplicateCharacterError extends Error {
    /**
     * Creates an instance of DuplicateCharacterError
     *
     * @param {object} [meta={source, duplicate}]
     * @memberof DuplicateCharacterError
     */
    constructor(source, duplicate) {
        super(`Alphabets cannot contain duplicate characters, found "${duplicate}" in "${source}"`);
        const { constructor, constructor: { name } } = this;
        this.name = name;
        Error.captureStackTrace(this, constructor);
    }
};

const storage$1 = new WeakMap();
const defaultCharacters = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
const stringable = (input) => /string|object/.test(type(input));
/**
 * Immutable alphabet
 *
 * @class Alphabet
 */
class Alphabet {
    constructor(source = defaultCharacters) {
        const characters = stringable(source) ? String(source) : '';
        const alphabet = Array.from(characters);
        const duplicate = alphabet.filter((v, i, a) => a.indexOf(v) !== i).join('');
        if (!characters.length) {
            throw new InvalidInputError$1(source);
        }
        if (duplicate.length) {
            throw new DuplicateCharacterError$1(characters, duplicate);
        }
        storage$1.set(this, { characters, alphabet });
    }
    /**
     * Obtain the configured characters
     *
     * @readonly
     * @memberof Alphabet
     */
    get characters() {
        const { characters } = storage$1.get(this);
        return characters;
    }
    /**
     * Get the number of bytes of the alphabet
     *
     * @readonly
     * @memberof Alphabet
     */
    get byteLength() {
        return this.characters.length;
    }
    /**
     * Get the character length of the alphabet
     *
     * @readonly
     * @memberof Alphabet
     */
    get length() {
        const { alphabet: { length } } = storage$1.get(this);
        return length;
    }
    /**
     * Extract part of the alphabet and return it as a (singleton) instance of alphabet
     *
     * @param {number} start
     * @param {number} end
     * @returns {Alphabet} instance
     * @memberof Alphabet
     */
    slice(start, end) {
        const { alphabet } = storage$1.get(this);
        const { constructor: Ctor } = Object.getPrototypeOf(this);
        return Ctor.from(alphabet.slice(start, end).join(''));
    }
    /**
     * Get the character at given index
     *
     * @param {number} index
     * @returns {string} char
     * @memberof Alphabet
     */
    charAt(index) {
        const { alphabet } = storage$1.get(this);
        return alphabet[index];
    }
    /**
     * Get the character code at given index
     *
     * @param {numer} index
     * @returns {number} charcode
     * @memberof Alphabet
     */
    charCodeAt(index) {
        const { characters, length } = this;
        return index >= 0 && index < length ? characters.charCodeAt(index) : undefined;
    }
    /**
     * Get the code point at given index
     *
     * @param {numer} index
     * @returns {number} codepoint
     * @memberof Alphabet
     */
    codePointAt(index) {
        const char = this.charAt(index);
        return char ? char.codePointAt(0) : undefined;
    }
    /**
     * Get the index of the given character
     *
     * @param {string} char
     * @returns {number} index
     * @memberof Alphabet
     */
    indexOf(char) {
        const { alphabet } = storage$1.get(this);
        return alphabet.indexOf(char);
    }
    /**
     * Map any amount of indices to the corresponding characters (wrapping the
     * indices around if they exceed the length of the alphabet)
     *
     * @param {number} ...list
     * @returns {string} [char]
     * @memberof Alphabet
     */
    map(...list) {
        const { length } = this;
        const normal = (index) => index < 0 ? normal(length + index) : index;
        return list.map((index) => this.charAt(normal(index) % length));
    }
    /**
     * Convert the Alphabet into a string
     *
     * @returns {string} chars
     * @memberof Alphabet
     */
    toString() {
        return this.characters;
    }
    /**
     * Ensure the Alphabet is properly JSON-stringified
     *
     * @returns
     * @memberof Alphabet
     */
    toJSON() {
        return String(this);
    }
    /**
     * Obtain a singleton instance of Alphabet representing the provided characters
     *
     * @static
     * @param {*} characters
     * @returns
     * @memberof Alphabet
     */
    static from(characters) {
        if (!storage$1.has(this)) {
            storage$1.set(this, new Map());
        }
        const map = storage$1.get(this);
        if (!map.has(characters)) {
            map.set(characters, new this(characters));
        }
        return map.get(characters);
    }
}

const storage = new WeakMap();
/**
 * Implement the common ISO 7064 implementation mechanics
 *
 * @class ISO7064
 */
class ISO7064 {
    constructor(options = {}) {
        storage.set(this, options);
    }
    /**
     * The algorithm name
     *
     * @readonly
     * @memberof ISO7064
     */
    get algorithm() {
        const { algorithm } = storage.get(this);
        return algorithm || 'Custom';
    }
    /**
     * The specification name
     *
     * @readonly
     * @memberof ISO7064
     */
    get specification() {
        const { algorithm } = this;
        return `ISO 7064, ${algorithm}`;
    }
    /**
     * The designation (always 0, except for the Modulus implementations)
     *
     * @readonly
     * @memberof ISO7064
     */
    get designation() {
        const { designation } = storage.get(this);
        return designation || 0;
    }
    /**
     * The alphabet of allowed characters and from which to obtain the indices
     *
     * @readonly
     * @memberof ISO7064
     */
    get indices() {
        const { indices, alphabet } = storage.get(this);
        return indices || alphabet;
    }
    /**
     * The checksum alphabet
     *
     * @readonly
     * @memberof ISO7064
     */
    get alphabet() {
        const { alphabet } = storage.get(this);
        return alphabet;
    }
    /**
     * The modulus
     *
     * @readonly
     * @memberof ISO7064
     */
    get modulus() {
        const { modulus, alphabet } = storage.get(this);
        return modulus || (alphabet && alphabet.length);
    }
    /**
     * The radix
     *
     * @readonly
     * @memberof ISO7064
     */
    get radix() {
        const { radix } = storage.get(this);
        return radix;
    }
    /**
     * Does the checksum consist of double digits
     *
     * @readonly
     * @memberof ISO7064
     */
    get double() {
        const { double } = storage.get(this);
        return double || false;
    }
    /**
     * Normalize input, removing any character not allowed in the input
     *
     * @param {string} input
     * @returns {string} normalized
     * @memberof ISO7064
     */
    normalize(input) {
        const { indices = 'a-zA-Z0-9' } = this;
        const purge = new RegExp(`[^${indices}]+`, 'g');
        return String(input)
            .toUpperCase()
            .replace(purge, '');
    }
    /**
     * Calculate the checksum for input
     *
     * @param {string} input
     * @returns {string} checksum
     * @memberof ISO7064
     */
    checksum(input) {
        throw new Error('Checksum method not implemented');
    }
    /**
     * Validate the input
     *
     * @param {string} input
     * @returns {boolean} valid
     * @memberof ISO7064
     */
    validate(input) {
        const { indices, alphabet, double } = this;
        const pattern = new RegExp(`([${indices}]+)([${alphabet}]{${Number(double) + 1}})`);
        const match = this.normalize(input).match(pattern);
        if (match) {
            const [, num, cc] = match;
            return this.checksum(num) === cc;
        }
        return false;
    }
    /**
     * Generate the normalized output including the checksum
     *
     * @param {string} input
     * @returns {string} generated
     * @memberof ISO7064
     */
    generate(input) {
        const normal = this.normalize(input);
        return `${normal}${this.checksum(input)}`;
    }
    /**
     * Create a new instance based on the current settings with optional overrides
     *
     * @param {object} options
     * @returns
     * @memberof ISO7064
     */
    factory(options = {}) {
        const { indices, alphabet, modulus, radix, double } = this;
        const { constructor: Ctor } = Object.getPrototypeOf(this);
        return new Ctor(Object.assign({ indices,
            alphabet,
            modulus,
            radix,
            double }, options));
    }
}

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise, SuppressedError, Symbol */


function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};

/**
 * Pure checksum calculation implementation
 *
 * @class PureISO7064
 * @extends {ISO7064}
 */
class PureISO7064 extends ISO7064 {
    /**
     * Creates an instance of PureISO7064
     *
     * @param {*} options
     * @memberof PureISO7064
     */
    constructor(options = {}) {
        const { alphabet, radix = 2, indices = alphabet === null || alphabet === void 0 ? void 0 : alphabet.slice(0, -1) } = options, rest = __rest(options, ["alphabet", "radix", "indices"]);
        super(Object.assign({ alphabet, indices, radix }, rest));
    }
    /**
     * Calculate the checksum for input
     *
     * @param {string} input
     * @returns {string} checksum
     * @memberof PureISO7064
     */
    checksum(input) {
        const { modulus, radix, double, indices, alphabet } = this;
        const initial = alphabet.charAt(0).repeat(Number(double) + 1);
        const normal = this.normalize(input) + initial;
        const sum = Array.from(normal)
            .map((char) => indices.indexOf(char))
            .reduce((carry, pos) => (carry * radix + pos) % modulus, 0);
        const checksum = (modulus + 1 - (sum % modulus)) % modulus;
        return (double
            ? [(checksum / radix) | 0, checksum % radix]
            : [checksum])
            .map((index) => alphabet.charAt(index))
            .join('');
    }
}

/**
 * Hybrid checksum calculation implementation
 *
 * @class HybridISO7064
 * @extends {ISO7064}
 */
class HybridISO7064 extends ISO7064 {
    /**
     * Calculate the checksum for input
     *
     * @param {string} input
     * @returns {string} checksum
     * @memberof HybridISO7064
     */
    checksum(input) {
        const { modulus: mod, indices, alphabet } = this;
        const sum = Array.from(this.normalize(input))
            .map((char) => indices.indexOf(char))
            .reduce((carry, pos) => (((carry % (mod + 1)) + pos) % mod || mod) * 2, mod) % (mod + 1);
        return alphabet.charAt((mod + 1 - sum) % mod);
    }
}

const alphabet = {
    num: Alphabet.from('0123456789'),
    numX: Alphabet.from('0123456789X'),
    alpha: Alphabet.from('ABCDEFGHIJKLMNOPQRSTUVWXYZ'),
    alphanum: Alphabet.from('0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ'),
    alphanumA: Alphabet.from('0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ*')
};
const Mod11_2 = new PureISO7064({
    algorithm: 'MOD 11-2',
    designation: 1,
    alphabet: alphabet.numX
});
const Mod37_2 = new PureISO7064({
    algorithm: 'MOD 37-2',
    designation: 2,
    alphabet: alphabet.alphanumA
});
const Mod97_10 = new PureISO7064({
    algorithm: 'MOD 97-10',
    designation: 3,
    modulus: 97,
    radix: 10,
    alphabet: alphabet.num,
    indices: alphabet.num,
    double: true
});
const Mod661_26 = new PureISO7064({
    algorithm: 'MOD 661-26',
    designation: 4,
    modulus: 661,
    radix: 26,
    alphabet: alphabet.alpha,
    indices: alphabet.alpha,
    double: true
});
const Mod1271_36 = new PureISO7064({
    algorithm: 'MOD 1271-36',
    designation: 5,
    modulus: 1271,
    radix: 36,
    alphabet: alphabet.alphanumA,
    double: true
});
const Mod11_10 = new HybridISO7064({
    algorithm: 'MOD 11,10',
    designation: 6,
    alphabet: alphabet.num
});
const Mod27_26 = new HybridISO7064({
    algorithm: 'MOD 27,26',
    designation: 7,
    alphabet: alphabet.alpha
});
const Mod37_36 = new HybridISO7064({
    algorithm: 'MOD 37,36',
    designation: 8,
    alphabet: alphabet.alphanum
});

exports.Alphabet = Alphabet;
exports.HybridISO7064 = HybridISO7064;
exports.ISO7064 = ISO7064;
exports.Mod11_10 = Mod11_10;
exports.Mod11_2 = Mod11_2;
exports.Mod1271_36 = Mod1271_36;
exports.Mod27_26 = Mod27_26;
exports.Mod37_2 = Mod37_2;
exports.Mod37_36 = Mod37_36;
exports.Mod661_26 = Mod661_26;
exports.Mod97_10 = Mod97_10;
exports.PureISO7064 = PureISO7064;


},{}],2:[function(require,module,exports){
!function(t,e){if("object"==typeof exports&&"object"==typeof module)module.exports=e();else if("function"==typeof define&&define.amd)define([],e);else{var i=e();for(var a in i)("object"==typeof exports?exports:t)[a]=i[a]}}(window,(function(){return function(t){var e={};function i(a){if(e[a])return e[a].exports;var s=e[a]={i:a,l:!1,exports:{}};return t[a].call(s.exports,s,s.exports,i),s.l=!0,s.exports}return i.m=t,i.c=e,i.d=function(t,e,a){i.o(t,e)||Object.defineProperty(t,e,{enumerable:!0,get:a})},i.r=function(t){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(t,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(t,"__esModule",{value:!0})},i.t=function(t,e){if(1&e&&(t=i(t)),8&e)return t;if(4&e&&"object"==typeof t&&t&&t.__esModule)return t;var a=Object.create(null);if(i.r(a),Object.defineProperty(a,"default",{enumerable:!0,value:t}),2&e&&"string"!=typeof t)for(var s in t)i.d(a,s,function(e){return t[e]}.bind(null,s));return a},i.n=function(t){var e=t&&t.__esModule?function(){return t.default}:function(){return t};return i.d(e,"a",e),e},i.o=function(t,e){return Object.prototype.hasOwnProperty.call(t,e)},i.p="",i(i.s=0)}([function(t,e,i){"use strict";i.r(e),i.d(e,"AriaTablist",(function(){return x}));var a=35,s=36,n=37,r=38,o=39,l=40,h=46,b=13,c=32,u={37:-1,38:-1,39:1,40:1},d=function(){function t(t){this.tabs=t.tabs,this.panels=t.panels,this.options=t.options,this.open=this.open.bind(t),this.close=this.close.bind(t),this.delete=this.delete.bind(t),this.destroy=this.destroy.bind(t),t.tablist.ariaTablist=this}return t.prototype.open=function(t,e){this.checkMultiple(),this.activateTabWithTimer.apply(this,[t,e,!0])},t.prototype.close=function(t,e){this.checkMultiple(),this.deactivateTab.apply(this,[t,e,!0]),this.makeFocusable()},t.prototype.delete=function(t){this.determineDeletable.call(this,t)},t.prototype.destroy=function(){this.destroy.call(this)},t}(),p=function(t){for(var e in void 0===t&&(t={}),this.delay=0,this.deletable=!1,this.focusableTabs=!1,this.focusablePanels=!0,this.arrowActivation=!1,this.allArrows=!1,this.tabSelector='[role="tab"]',this.tabindex=0,t)t.hasOwnProperty(e)&&void 0!==t[e]&&(this[e]=t[e])};function f(t){t&&"function"==typeof t.preventDefault&&t.preventDefault()}function v(t,e){return t.getAttribute&&t.getAttribute(e)||""}function y(t,e,i){t&&v(t,e)!==i&&t.setAttribute&&t.setAttribute(e,i)}function T(t,e){t&&e&&t.removeAttribute&&e.split(" ").forEach((function(e){return e&&t.removeAttribute(e)}))}var m=0,g=function(){function t(t,e){if(this.tabs=[],this.panels=[],t&&1===t.nodeType){var i=t.ariaTablist;i&&"function"==typeof i.destroy&&i.destroy(),m+=1,this.tablist=t,this.options=new p(e),this.api=new d(this),this.init()}}return t.prototype.checkMultiple=function(){this.multiple="true"===v(this.tablist,"aria-multiselectable")},t.prototype.triggerOptionCallback=function(t,e){if(void 0===e&&(e=[]),this.options&&"function"==typeof this.options[t])return this.options[t].apply(this.api,e)},t.prototype.makeFocusable=function(){for(var t=""+(this.options.tabindex||0),e=0,i=this.tabs.length;e<i;e+=1)if(v(this.tabs[e],"tabindex")===t)return;y(this.tabs[0],"tabindex",t)},t.prototype.setCoreAttributes=function(t,e,i){var a=this.options.tabindex||"0";this.options.focusableTabs&&y(t,"tabindex",a),this.options.focusablePanels&&y(e,"tabindex",a),t.id||y(t,"id","aria-tablist-"+m+"-tab-"+i),e.id||y(e,"id","aria-tablist-"+m+"-panel-"+i),y(t,"role","tab"),y(e,"role","tabpanel"),y(t,"aria-controls",e.id),y(e,"aria-labelledby",t.id)},t.prototype.getTabPanel=function(t){var e="number"==typeof t?this.tabs[t]:t;if(!e||1!==e.nodeType)return null;var i="number"==typeof t?this.panels[t]:null;if(i)return i;var a=v(e,"aria-controls");return a||(a=v(e,"data-controls")),a&&(i=document.getElementById(a)),i||(a&&T(e,"aria-controls"),e.id&&(i=document.querySelector('[aria-labelledby="'+e.id+'"]')),i||(i=document.querySelector('[data-labelledby="'+e.id+'"]'))),i},t.prototype.generateArrays=function(t){this.tabs.splice(0),this.panels.splice(0);var e=this.tablist.querySelectorAll(this.options.tabSelector);t&&!e.length&&(e=this.tablist.childNodes);for(var i=0,a=e.length;i<a;i+=1){var s=e[i];if(s&&1===s.nodeType&&!(this.panels.indexOf(s)>-1)){var n=this.getTabPanel(s);n?(this.tabs.push(s),this.panels.push(n),this.setCoreAttributes(s,n,i),s._ariaTablistTabIndex=this.tabs.length-1):"tab"===v(s,"role")&&T(s,"role")}}},t.prototype.elementIsTab=function(t){return!!(t&&this.tabs.indexOf(t)>-1)},t.prototype.addListenersToTab=function(t){var e=this.tabs[t];e.addEventListener("keydown",this.tabKeydownEvent),e.addEventListener("keyup",this.tabKeyupEvent),e.addEventListener("click",this.tabClickEvent)},t.prototype.tabClickEvent=function(t){var e=t.target;do{if(this.elementIsTab(e))return this.checkMultiple(),f(t),this.activateTabWithTimer(e,!1);e=e.parentElement||e.parentNode}while(null!==e&&1===e.nodeType)},t.prototype.tabKeydownEvent=function(t){if(this.elementIsTab(t.target))switch(t.keyCode){case a:f(t),this.focusLastTab();break;case s:f(t),this.focusFirstTab();break;case r:case l:case n:case o:this.processArrowPress(t);break;case c:case b:f(t)}},t.prototype.tabKeyupEvent=function(t){var e=t.target;if(this.elementIsTab(e))switch(t.keyCode){case h:this.determineDeletable(e);break;case b:case c:this.checkMultiple(),f(t),this.activateTabWithTimer(e)}},t.prototype.processArrowPress=function(t){var e=t.keyCode;(this.options.allArrows||("vertical"===v(this.tablist,"aria-orientation")?e===r||e===l:e===n||e===o))&&this.switchTabOnArrowPress(t)},t.prototype.switchTabOnArrowPress=function(t){var e=t.keyCode,i=u[e],a=t.target._ariaTablistTabIndex;if(i&&"number"==typeof a){f(t);var s=(e===n||e===o)&&("rtl"===document.dir||"rtl"===this.tablist.dir);s&&"ltr"!==this.tablist.dir&&(i*=-1);var h=a+i;this.tabs[h]?this.focusTab(h):e===n||e===r?s?this.focusFirstTab():this.focusLastTab():e!==o&&e!=l||(s?this.focusLastTab():this.focusFirstTab())}},t.prototype.getTab=function(t){return"number"==typeof t&&this.elementIsTab(this.tabs[t])?this.tabs[t]:this.elementIsTab(t)?t:null},t.prototype.activateTabWithTimer=function(t,e,i){var a=this;this.tabTimer&&clearTimeout(this.tabTimer);var s="number"==typeof this.options.delay?this.options.delay:0;this.tabTimer=setTimeout((function(){a.activateTab(t,e,i)}),s)},t.prototype.activateTab=function(t,e,i){void 0===e&&(e=!0),void 0===i&&(i=!1);var a=this.getTab(t);if(a&&e&&a.focus(),a&&(i||"true"!==v(a,"aria-disabled"))){var s="true"===v(a,"aria-selected");if(this.multiple&&s&&!i)return this.deactivateTab(a),void this.makeFocusable();this.multiple||this.deactivateTabs([a]);var n=this.options.tabindex||"0";y(a,"tabindex",n),y(a,"aria-selected","true");var r=this.getTabPanel(t);if(r){var o="hidden"===v(r,"hidden");T(r,"hidden aria-hidden"),this.multiple&&(y(r,"aria-expanded","true"),y(a,"aria-expanded","true")),this.options.focusablePanels&&y(r,"tabindex",n),o&&this.triggerOptionCallback("onOpen",[r,a])}}},t.prototype.deactivateTab=function(t,e,i){void 0===e&&(e=!1),void 0===i&&(i=!1);var a=this.getTab(t);if(a&&(e&&a.focus(),y(a,"tabindex",this.options.focusableTabs?this.options.tabindex||"0":"-1"),i||"true"!==v(a,"aria-disabled"))){y(a,"aria-selected","false");var s=this.getTabPanel(t);if(s){var n="hidden"===v(s,"hidden");T(s,"tabindex"),y(s,"hidden","hidden"),y(s,"aria-hidden","true"),this.multiple?(y(a,"aria-expanded","false"),y(s,"aria-expanded","false")):(T(s,"aria-expanded"),T(a,"aria-expanded")),n||this.triggerOptionCallback("onClose",[s,a])}}},t.prototype.deactivateTabs=function(t){var e=this;void 0===t&&(t=[]);var i=Array.isArray(t);this.tabs.forEach((function(a){i&&-1!==t.indexOf(a)||e.deactivateTab(a,!1,!0)}))},t.prototype.focusTab=function(t){var e=this.getTab(t),i=this.options.arrowActivation;if(e){if(i&&"true"!==v(e,"aria-selected"))return void this.activateTabWithTimer(e);e.focus()}},t.prototype.focusFirstTab=function(){this.focusTab(0)},t.prototype.focusLastTab=function(){this.focusTab(this.tabs.length-1)},t.prototype.determineDeletable=function(t){if(this.options.deletable){var e=this.getTab(t);if(e&&"false"!==v(e,"data-deletable")){this.checkMultiple(),this.deleteTab(e),this.generateArrays();var i=e._ariaTablistTabIndex,a=i-1>-1?i-1:0;this.multiple||"true"!==v(e,"aria-selected")?this.tabs[a]&&this.tabs[a].focus():this.activateTab(a),this.makeFocusable(),this.triggerOptionCallback("onDelete",[e])}}},t.prototype.deleteTab=function(t){var e=this.getTabPanel(t);t.parentElement.removeChild(t),e&&e.parentElement.removeChild(e)},t.prototype.destroy=function(){var t=this,e="aria-expanded aria-hidden hidden role tabindex";this.tabs.forEach((function(i,a){i.removeEventListener("keydown",t.tabKeydownEvent),i.removeEventListener("keyup",t.tabKeyupEvent),i.removeEventListener("click",t.tabClickEvent),T(t.panels[a],e),T(i,e),delete i._ariaTablistTabIndex})),this.tablist&&(delete this.tablist.ariaTablist,T(this.tablist,"role")),this.panels.splice(0),this.tabs.splice(0),this.tablist=null},t.prototype.init=function(){var t=this;this.checkMultiple(),this.generateArrays(!0),this.tabKeydownEvent=this.tabKeydownEvent.bind(this),this.tabClickEvent=this.tabClickEvent.bind(this),this.tabKeyupEvent=this.tabKeyupEvent.bind(this);var e=[];this.tabs.forEach((function(i,a){t.addListenersToTab(a),!("true"===v(i,"aria-selected")||"true"===v(i,"data-selected"))||!t.multiple&&e.length||e.push(i)})),y(this.tablist,"role","tablist"),this.tabs.length&&(this.multiple||e.length||e.push(this.tabs[0]),this.deactivateTabs(e),e.forEach((function(e){return t.activateTab(e,!1,!0)})),this.makeFocusable()),this.triggerOptionCallback("onReady",[this.tablist])},t}();function x(t,e){return new g(t,e).api}e.default=x}])}));
},{}],3:[function(require,module,exports){
"use strict";

var _ariaTablist = _interopRequireDefault(require("aria-tablist"));
var _selectFormFloating = _interopRequireDefault(require("./select-form-floating"));
var _iso = require("@konfirm/iso7064");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
// https://github.com/mynamesleon/aria-tablist

(function ($) {
  $.fn.SdKeyCheckDo = function (value) {
    var sdLength = 14;
    if (value.length < sdLength) {
      return null;
    }
    var smartData = null;
    var fullSd = null;
    var sdKey = null;
    if (value.length === sdLength) {
      smartData = value;
      sdKey = _iso.Mod37_36.checksum(smartData);
      fullSd = smartData.toString() + sdKey;
    } else {
      fullSd = value;
      var aFullSd = fullSd.toString().match(new RegExp(".{1,".concat(sdLength, "}"), 'g'));
      smartData = parseInt(aFullSd[0], 10);
      sdKey = aFullSd[1];
    }
    var valide = _iso.Mod37_36.validate(fullSd);
    return valide;
  };
  var Navigation = {
    initialize: function initialize() {
      var navItem = $('li[class*="header__li-level-"]');
      $('body').on('keydown', '.btn-menu', Navigation.focusBtnMenu);
      $('.header__li-level-1:last > div').find('> a:last-child, > button').on('keydown', Navigation.lastTabFocus);
      $('.header__level-2-wrapper li:last-child').find('a:first, button:first').on('keydown', Navigation.levelLastTabFocus);
      navItem.on('mouseenter', Navigation.navItemMouseEnter);
      navItem.on('mouseleave', Navigation.navItemMouseLeave);
      $('.header__lk-level-1 > a').on('keydown', Navigation.navItemTabEnter);
      $('li[class*="header__li-level-"] .btn-expand').on('click', Navigation.navToggleBtnExpand);
      $('header .btn-back').on('click', Navigation.returnLevelParent);
      if ($('.btn-menu').is(':visible')) {
        $('.header__level-2-wrapper').find('a, button').attr('tabindex', '-1');
      }
      $('.js-header li a').each(function () {
        $(this).attr('href') === window.location.pathname ? $(this).attr('aria-current', 'true') : $(this).attr('aria-current', 'false');
      });
    },
    focusBtnMenu: function focusBtnMenu(e) {
      if (e.key === "Tab" && !e.shiftKey && $('.btn-menu__active').length) {
        e.preventDefault();
        $('.header__main-nav a').first().focus();
      }
    },
    navItemMouseEnter: function navItemMouseEnter(e) {
      if (!$('.btn-menu').is(':visible')) {
        var target = $(e.currentTarget);
        var wrapper = $(target).find('.header__level-2-wrapper');
        wrapper.attr('aria-hidden', false);
        wrapper.addClass('header__level-2-wrapper__visible');
      }
    },
    navItemMouseLeave: function navItemMouseLeave(e) {
      if (!$('.btn-menu').is(':visible')) {
        var target = $(e.currentTarget);
        var wrapper = $(target).find('.header__level-2-wrapper');
        wrapper.attr('aria-hidden', true);
        wrapper.removeClass('header__level-2-wrapper__visible');
      }
    },
    navToggleBtnExpand: function navToggleBtnExpand(e) {
      var target = $(e.currentTarget),
        status = null;
      var expanded = status !== null ? status : $(target).attr('aria-expanded') === 'true';
      var wrapper = $(target).parents('.header__li-level-1').find('.header__level-2-wrapper');
      if (!expanded) {
        $(target).addClass('btn-expand__active');
        $(target).attr('aria-expanded', true);
        wrapper.attr('aria-hidden', false);
        wrapper.addClass('header__level-2-wrapper__visible');
      } else {
        $(target).removeClass('btn-expand__active');
        $(target).attr('aria-expanded', false);
        wrapper.attr('aria-hidden', true);
        wrapper.removeClass('header__level-2-wrapper__visible');
      }
      if ($('.btn-menu').is(':visible')) {
        wrapper.find('a').first().focus();
        wrapper.find('> ul > li > *').removeAttr('tabindex');
        wrapper.find('> ul > li > div > *').removeAttr('tabindex');
      }
    },
    returnLevelParent: function returnLevelParent(e) {
      var target = $(e.currentTarget);
      var wrapper = $(target).closest('.header__level-2-wrapper');
      var prevExpand = $(target).parents('.header__li-level-1').find('.btn-expand');
      wrapper.attr('aria-hidden', 'true');
      wrapper.removeClass('header__level-2-wrapper__visible');
      wrapper.find('a, button').attr('tabindex', '-1');
      prevExpand.attr('aria-expanded', 'false');
      prevExpand.removeClass('btn-expand__active');
      prevExpand.focus();
    },
    lastTabFocus: function lastTabFocus(e) {
      if (e.key === "Tab" && !e.shiftKey && $('.btn-menu').is(':visible')) {
        e.preventDefault();
        $('.btn-menu').focus();
      }
    },
    levelLastTabFocus: function levelLastTabFocus(e) {
      var target = $(e.currentTarget);
      if (e.key === "Tab" && !e.shiftKey && $('.btn-menu').is(':visible')) {
        e.preventDefault();
        $(target).closest('ul').find('> li > .btn-back').focus();
      }
    },
    navItemTabEnter: function navItemTabEnter(e) {
      if (e.key === 'Tab' && !$('.btn-menu').is(':visible')) {
        $('[class*="header__level-"]').attr('aria-hidden', true).removeClass('header__level-2-wrapper__visible');
      }
    }
  };
  var dashboard = {
    initialize: function initialize() {
      $('.dashboard__perimeter').prependTo('main').find('.js-form-submit').wrap('<div class="dashboard__perimeter__submit">');
      $('.dashboard__perimeter--exit, .dashboard__perimeter--forms').find('input, select, button , a').attr('tabindex', '-1');
      $('.dashboard__perimeter .js-form-item-coclico').addClass('form-floating');
      $('.dashboard__perimeter .btn--small, .open-menu2, .open-menu').on('click', dashboard.toggleDashboard);
      $('.dashboard__perimeter .btn-close').on('click', dashboard.closeDashboard);
      dashboard.setPerimeterProperties();
      $(window).on('resize', dashboard.setPerimeterProperties);
    },
    toggleDashboard: function toggleDashboard(e) {
      var target = $(e.currentTarget);
      var dashboard = $('.dashboard__perimeter');
      e.preventDefault();
      $(target).toggleClass('btn--small--open');
      if ($(target).hasClass('dashboard__perimeter--open')) {
        $('.dashboard__perimeter .btn--small, .open-menu2, .open-menu').attr('aria-expanded', 'false');
      } else {
        $(target).attr('aria-expanded', 'true');
        $('.dashboard__perimeter--exit, .dashboard__perimeter--forms').attr('aria-hidden', 'false');
        dashboard.find('input:first').focus();
      }
      $('.dashboard__perimeter--backdrop').toggleClass('dashboard__perimeter--backdrop--open');
      dashboard.toggleClass('dashboard__perimeter--open');
      $('.dashboard__perimeter--exit, .dashboard__perimeter--forms').find('input, select, button , a').removeAttr('tabindex');
    },
    closeDashboard: function closeDashboard(e) {
      var dashboard = $('.dashboard__perimeter');
      e.preventDefault();
      $('.dashboard__perimeter .btn--small').removeClass('btn--small--open');
      $('.dashboard__perimeter--backdrop').removeClass('dashboard__perimeter--backdrop--open');
      dashboard.removeClass('dashboard__perimeter--open');
      $('.dashboard__perimeter .btn--small, .open-menu2, .open-menu').attr('aria-expanded', 'false');
      $('.dashboard__perimeter--exit, .dashboard__perimeter--forms').attr('aria-hidden', 'true');
      dashboard.find('input, select, button , a').attr('tabindex', '-1');
    },
    setPerimeterProperties: function setPerimeterProperties() {
      var headerHeight = $(".header__wrapper").height();
      var perimeter = $('.dashboard__perimeter');
      $(document).ready(function () {
        var perimeterHeight = $('.dialog-off-canvas-main-canvas').height() - headerHeight;
        if (perimeterHeight !== $('.dashboard__perimeter--exit').css('height')) {
          $('.dashboard__perimeter--exit').css('height', perimeterHeight);
        }
      });
      if (parseInt(perimeter.css('top')) !== headerHeight) {
        perimeter.css('top', headerHeight);
      }
    }
  };
  var Tabs = {
    initialize: function initialize() {
      document.querySelectorAll('.js-tabs').forEach(function (elem) {
        (0, _ariaTablist["default"])(elem, {
          arrowActivation: true
        });
      });
    }
  };
  var HelpWidget = {
    initialize: function initialize() {
      HelpWidget.clickOutside();
      HelpWidget.trapFocus();
      $('.helps__button').on('click', HelpWidget.toggleHelp);
    },
    clickOutside: function clickOutside() {
      $(window).click(function (e) {
        var $elem = $(e.target);
        if (!$elem.hasClass('helps') && !$elem.parents().hasClass('helps')) {
          $('.helps').removeClass('is-open');
          $('.helps__button').attr('aria-expanded', 'false');
          $('.helps__cta a').attr('aria-hidden', 'true');
          $('.helps__cta a').attr('tabindex', '-1');
        }
      });
    },
    toggleHelp: function toggleHelp(e) {
      var $elem = $(e.currentTarget);
      var $helps = $elem.closest('#helps');
      var $link = $('.helps__cta a');
      if ($helps.hasClass('is-open')) {
        $helps.removeClass('is-open');
        $elem.attr('aria-expanded', 'false');
        $link.attr('aria-hidden', 'true');
        $link.attr('tabindex', '-1');
      } else {
        $helps.addClass('is-open');
        $elem.attr('aria-expanded', 'true');
        $link.attr('aria-hidden', 'false');
        $link.removeAttr('tabindex');
      }
    },
    trapFocus: function trapFocus() {
      var tabbable = $('#helps a').filter(':visible');
      var firstTabbable = tabbable.first();
      var lastTabbable = tabbable.last();
      firstTabbable.on('keydown', function (e) {
        if (e.key === 'Tab' && e.shiftKey) {
          e.preventDefault();
          $('.helps__button').focus();
        }
      });
      lastTabbable.on('keydown', function (e) {
        if (e.key === 'Tab' && !e.shiftKey) {
          e.preventDefault();
          $('.helps__button').focus();
        }
      });
      $('.helps__button').on('keydown', function (e) {
        if (e.key === 'Tab' && e.shiftKey && $('#helps').hasClass('is-open')) {
          e.preventDefault();
          lastTabbable.focus();
        }
      });
    }
  };
  var ParsleyValidation = {
    initialize: function initialize() {
      // Parsley validation
      var contactForm = $('#contact-form');
      contactForm.find('.fieldgroup').removeAttr('required');
      contactForm.find('.fieldgroup .form-radio').attr({
        'required': true,
        'aria-required': true
      });
      Parsley.addMessages('fr', {
        defaultMessage: 'Champ obligatoire !',
        type: {
          email: 'Veuillez saisir une adresse e-mail valide. Exemple : exemple@net.com'
        }
      });
      contactForm.parsley();
      window.Parsley.on('field:error', function (formInstance) {
        $(formInstance.element).attr('aria-invalid', true);
        if ($(formInstance.element).is('#edit-civilite-m')) {
          var msgId = $(formInstance.element).parents('.js-form-wrapper').find('.parsley-errors-list').attr('id');
          $(formInstance.element).attr('aria-describedby', msgId);
        }
      });
      window.Parsley.on('field:success', function (formInstance) {
        $(formInstance.element).attr('aria-invalid', false).removeAttr('aria-describedby');
      });
      window.Parsley.addValidator('siret', {
        validateString: function validateString(value) {
          var patt = new RegExp(/^[0-9]{14}$/);
          return patt.test(value);
        },
        messages: {
          fr: 'Le numéro Siret est mal construit'
        }
      });
      window.Parsley.addValidator('coclico', {
        validateString: function validateString(value) {
          var patt = new RegExp(/^[0-9]{1,8}$/);
          return patt.test(value);
        },
        messages: {
          fr: 'Le COCLICO doit être composé de 1 à 8 chiffres'
        }
      });
      window.Parsley.addValidator('phone', {
        validateString: function validateString(value) {
          var patt = new RegExp(/^0[1-9]([-. ]?[0-9]{2}){4}$/);
          return patt.test(value);
        },
        messages: {
          fr: 'Le numéro de téléphone n\'est pas valide. Exemple : 0123456789'
        }
      });
    }
  };
  $(document).ready(function () {
    // Initialize all popovers
    var defaultWhiteList = $.fn.tooltip.Constructor.Default.whiteList;
    defaultWhiteList.button = ['class'];
    $('[data-toggle="popover"]').popover({
      whiteList: defaultWhiteList // In order to display buttons: https://github.com/twbs/bootstrap/issues/30764
    });

    // initialize all tooltips
    $('[data-toggle="tooltip"]').tooltip();

    // Navigation
    Navigation.initialize();

    // Dashboard
    dashboard.initialize();

    // Tabs
    Tabs.initialize();

    // Selects
    (0, _selectFormFloating["default"])();

    // Parsley validation
    ParsleyValidation.initialize();

    // Fix accessibility bootstrap-select
    $('body').on('keypress', '.bootstrap-select .dropdown-menu a', function (e) {
      if (e.which === 13) {
        $(e.target).trigger('click');
      }
    });

    // Back to top
    $('.js-btn-back-to-top').on('click', function () {
      $('html, body').animate({
        scrollTop: 0
      }, 1000);
      $('body').attr('tabindex', 0).focus();
    });

    // Help
    HelpWidget.initialize();

    // Datatables
    $('.dataTables_filter input').addClass('form-control');

    // FAQ tabs
    var faq = $('.faq-container');
    faq.find('.nav-tabs').wrap('<div class="nav-tabs-container">');
    faq.find('.nav-tabs li.active a').addClass('active').attr('aria-expanded', 'true');
  });
})(jQuery);
},{"./select-form-floating":4,"@konfirm/iso7064":1,"aria-tablist":2}],4:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var selectFormFloating = function selectFormFloating() {
  var select = document.querySelectorAll('.form-floating select');
  if (select.length) {
    select.forEach(function (item) {
      var setClass = function setClass() {
        item.value ? item.classList.add('has-value') : item.classList.remove('has-value');
      };
      window.onload = function () {
        setClass();
      };
      item.addEventListener('change', function () {
        setClass();
      });
    });
  }
};
var _default = selectFormFloating;
exports["default"] = _default;
},{}]},{},[3]);
